import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { persistor } from '../../../app/store'
import { deleteDossier } from '../../../features/dossier/dossierThunks'
import { resetMaps } from '../../../features/maps/mapsSlice'
import { setActiveZone } from '../../../features/Zone/zoneThunks'
import { resetZone } from '../../../features/Zone/zoneSlice'
import { resetZonesDetector } from '../../../features/zonesDetector/zonesDetectorSlice'
import { clearUserServerCache } from '../../../features/user/userThunks'
import { clearActivePOI, clearNearbyPOIs } from '../../../features/poi/poiSlice'
import { clearScene } from '../../../features/scene/sceneSlice'
import { resetDossier } from '../../../features/dossier/dossierSlice'
import { clearPuzzle } from '../../../features/puzzle/puzzleSlice'
import { clearScripts } from '../../../features/script/scriptSlice'

const useDebugExitZone = () => {
  const dispatch = useAppDispatch()

  const debug = process.env.REACT_APP_DEBUG === 'true' ? true : false
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  // =======================
  // Selectors
  // =======================
  const { data: zoneData } = useAppSelector((state) => state.zone)
  const activeZoneId = zoneData?.id

  // =======================
  // Handlers
  // =======================

  const handleExitZone = async () => {
    // Reset backend zone state
    await dispatch(setActiveZone({}))

    // Clear all persisted slices
    await persistor.purge()

    dispatch(resetZonesDetector())
    dispatch(resetZone())

    dispatch(clearNearbyPOIs())
    dispatch(clearActivePOI())
    dispatch(clearScene())

    dispatch(resetDossier())
    dispatch(clearPuzzle())
    dispatch(clearScripts())
    dispatch(resetMaps())

    console.log('Reset settings - done')

    // ✅ Optional: clear app version/localStorage/etc
    // localStorage.removeItem('persist:root') // if needed

    window.location.href = '/'
  }

  const handleExitZoneAndDelete = async () => {
    if (activeZoneId) {
      // on success response, reset app and redirect
      const response = await dispatch(deleteDossier(activeZoneId))
      response && handleExitZone()
    }
  }

  const handleClearServerCache = () => {
    dispatch(clearUserServerCache())
  }

  return {
    debug,
    debugP2,
    handlers: {
      handleExitZone,
      handleExitZoneAndDelete,
      handleClearServerCache,
    },
  }
}

export default useDebugExitZone
